module.exports = __webpack_public_path__ + "static/img/thumb_6.3a919f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_6.png
// module id = ylMX
// module chunks = 0